export const BASE_URL = "https://jsonplaceholder.typicode.com"
export const GET_TEAM = "GET_TEAM"
export const GET_TEAM_SUCCESS = "GET_TEAM_SUCCESS"
export const SHOOT_GET_POST = "GET_POST"
export const GET_POST_SUCCESS = "GET_POST_SUCCESS"